/** The `$TICKER` fragment shown at the start of a result subline. */
export function tickerLabel(ticker: string | undefined): string | null {
  return ticker === undefined || ticker.length === 0 ? null : `$${ticker}`;
}
